import React from 'react';
import Header from '../../../../../Header/Header';
import Navigationbar from '../../../../../Navigationbar/Navigationbar';
import CSCEMetric from './CSCEMetric';

/**
 * Used to show the action item on the nav bar and when user clicks on 
 * that it will take the user to the particular component
 * @param {*} props 
 * @returns 
 */
const CSCEMetricsWrapper = (props) => {

    const { themeSelected } = props;

    return (
        <div className='container-fluid m-1'>
            <Header {...props} />
            <Navigationbar {...props} />
            <CSCEMetric className='mt-3' themeSelected={themeSelected} />
        </div>
    )
}

export default CSCEMetricsWrapper;